import { render, staticRenderFns } from "./NavsMenuItem.vue?vue&type=template&id=43dd5ac1&scoped=true&"
import script from "./NavsMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavsMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./NavsMenuItem.vue?vue&type=style&index=0&id=43dd5ac1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dd5ac1",
  null
  
)

export default component.exports